module.exports = __webpack_public_path__ + "static/img/18.b7928af6.png";